import React, { useState, useRef, useEffect } from 'react';
import './CountryPhoneInput.css';

// Список популярных стран
const COUNTRIES = [
  { code: '+7', flag: '🇷🇺', name: 'Россия', dialCode: '+7' },
  { code: '+1', flag: '🇺🇸', name: 'США', dialCode: '+1' },
  { code: '+44', flag: '🇬🇧', name: 'Великобритания', dialCode: '+44' },
  { code: '+49', flag: '🇩🇪', name: 'Германия', dialCode: '+49' },
  { code: '+33', flag: '🇫🇷', name: 'Франция', dialCode: '+33' },
  { code: '+39', flag: '🇮🇹', name: 'Италия', dialCode: '+39' },
  { code: '+34', flag: '🇪🇸', name: 'Испания', dialCode: '+34' },
  { code: '+86', flag: '🇨🇳', name: 'Китай', dialCode: '+86' },
  { code: '+81', flag: '🇯🇵', name: 'Япония', dialCode: '+81' },
  { code: '+82', flag: '🇰🇷', name: 'Южная Корея', dialCode: '+82' },
  { code: '+91', flag: '🇮🇳', name: 'Индия', dialCode: '+91' },
  { code: '+61', flag: '🇦🇺', name: 'Австралия', dialCode: '+61' },
  { code: '+55', flag: '🇧🇷', name: 'Бразилия', dialCode: '+55' },
  { code: '+52', flag: '🇲🇽', name: 'Мексика', dialCode: '+52' },
  { code: '+31', flag: '🇳🇱', name: 'Нидерланды', dialCode: '+31' },
  { code: '+32', flag: '🇧🇪', name: 'Бельгия', dialCode: '+32' },
  { code: '+41', flag: '🇨🇭', name: 'Швейцария', dialCode: '+41' },
  { code: '+46', flag: '🇸🇪', name: 'Швеция', dialCode: '+46' },
  { code: '+47', flag: '🇳🇴', name: 'Норвегия', dialCode: '+47' },
  { code: '+45', flag: '🇩🇰', name: 'Дания', dialCode: '+45' },
  { code: '+358', flag: '🇫🇮', name: 'Финляндия', dialCode: '+358' },
  { code: '+48', flag: '🇵🇱', name: 'Польша', dialCode: '+48' },
  { code: '+420', flag: '🇨🇿', name: 'Чехия', dialCode: '+420' },
  { code: '+36', flag: '🇭🇺', name: 'Венгрия', dialCode: '+36' },
  { code: '+40', flag: '🇷🇴', name: 'Румыния', dialCode: '+40' },
  { code: '+380', flag: '🇺🇦', name: 'Украина', dialCode: '+380' },
  { code: '+375', flag: '🇧🇾', name: 'Беларусь', dialCode: '+375' },
  { code: '+7', flag: '🇰🇿', name: 'Казахстан', dialCode: '+7' },
  { code: '+998', flag: '🇺🇿', name: 'Узбекистан', dialCode: '+998' },
  { code: '+996', flag: '🇰🇬', name: 'Кыргызстан', dialCode: '+996' },
  { code: '+374', flag: '🇦🇲', name: 'Армения', dialCode: '+374' },
  { code: '+994', flag: '🇦🇿', name: 'Азербайджан', dialCode: '+994' },
  { code: '+995', flag: '🇬🇪', name: 'Грузия', dialCode: '+995' },
  { code: '+90', flag: '🇹🇷', name: 'Турция', dialCode: '+90' },
  { code: '+971', flag: '🇦🇪', name: 'ОАЭ', dialCode: '+971' },
  { code: '+966', flag: '🇸🇦', name: 'Саудовская Аравия', dialCode: '+966' },
  { code: '+972', flag: '🇮🇱', name: 'Израиль', dialCode: '+972' },
  { code: '+20', flag: '🇪🇬', name: 'Египет', dialCode: '+20' },
  { code: '+27', flag: '🇿🇦', name: 'ЮАР', dialCode: '+27' },
  { code: '+65', flag: '🇸🇬', name: 'Сингапур', dialCode: '+65' },
  { code: '+60', flag: '🇲🇾', name: 'Малайзия', dialCode: '+60' },
  { code: '+66', flag: '🇹🇭', name: 'Таиланд', dialCode: '+66' },
  { code: '+84', flag: '🇻🇳', name: 'Вьетнам', dialCode: '+84' },
  { code: '+62', flag: '🇮🇩', name: 'Индонезия', dialCode: '+62' },
  { code: '+63', flag: '🇵🇭', name: 'Филиппины', dialCode: '+63' },
  { code: '+64', flag: '🇳🇿', name: 'Новая Зеландия', dialCode: '+64' },
  { code: '+351', flag: '🇵🇹', name: 'Португалия', dialCode: '+351' },
  { code: '+30', flag: '🇬🇷', name: 'Греция', dialCode: '+30' },
  { code: '+353', flag: '🇮🇪', name: 'Ирландия', dialCode: '+353' },
  { code: '+358', flag: '🇫🇮', name: 'Финляндия', dialCode: '+358' },
  { code: '+357', flag: '🇨🇾', name: 'Кипр', dialCode: '+357' },
];

const CountryPhoneInput = ({ value, onChange, disabled, placeholder = "Номер телефона" }) => {
  const [selectedCountry, setSelectedCountry] = useState(COUNTRIES[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Парсим текущий номер для определения страны
  useEffect(() => {
    if (value) {
      // Пытаемся найти страну по коду
      const foundCountry = COUNTRIES.find(country => value.startsWith(country.dialCode));
      if (foundCountry) {
        setSelectedCountry(foundCountry);
      }
    }
  }, []);

  // Закрытие dropdown при клике вне его
  useEffect(() => {
    if (!isDropdownOpen) return;
    
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          inputRef.current && !inputRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    // Небольшая задержка, чтобы не закрыть сразу после открытия
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 200);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const filteredCountries = COUNTRIES;

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
    
    // Обновляем значение, заменяя старый код страны на новый
    if (value) {
      const oldCode = COUNTRIES.find(c => value.startsWith(c.dialCode))?.dialCode || '';
      const phoneNumber = oldCode ? value.replace(oldCode, '') : value;
      onChange(country.dialCode + phoneNumber);
    } else {
      onChange(country.dialCode);
    }
  };

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;
    
    // Если начинается с +, парсим код страны
    if (inputValue.startsWith('+')) {
      const foundCountry = COUNTRIES.find(country => inputValue.startsWith(country.dialCode));
      if (foundCountry) {
        setSelectedCountry(foundCountry);
        onChange(inputValue);
      } else {
        onChange(inputValue);
      }
    } else {
      // Если не начинается с +, добавляем код выбранной страны
      onChange(selectedCountry.dialCode + inputValue);
    }
  };

  // Получаем номер без кода страны для отображения
  const getPhoneNumberWithoutCode = () => {
    if (!value) return '';
    const countryCode = selectedCountry.dialCode;
    if (value.startsWith(countryCode)) {
      return value.substring(countryCode.length);
    }
    return value;
  };

  return (
    <div className="country-phone-input-wrapper">
      <div className="country-selector" ref={dropdownRef}>
        <button
          type="button"
          className="country-selector-button"
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) {
              setIsDropdownOpen(prev => !prev);
            }
          }}
          disabled={disabled}
        >
          <span className="country-flag">{selectedCountry.flag}</span>
          <span className="country-code">{selectedCountry.dialCode}</span>
          <span className="country-arrow">▼</span>
        </button>
        
        {isDropdownOpen && (
          <div 
            className="country-dropdown" 
            onClick={(e) => e.stopPropagation()} 
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div className="country-list">
              {filteredCountries.map((country) => (
                <div
                  key={country.code}
                  className={`country-item ${selectedCountry.code === country.code ? 'selected' : ''}`}
                  onClick={() => handleCountrySelect(country)}
                >
                  <span className="country-flag">{country.flag}</span>
                  <span className="country-name">{country.name}</span>
                  <span className="country-dial-code">{country.dialCode}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      
      <input
        ref={inputRef}
        type="tel"
        value={getPhoneNumberWithoutCode()}
        onChange={handlePhoneChange}
        onFocus={() => {
          // Если поле пустое, добавляем код страны
          if (!value) {
            onChange(selectedCountry.dialCode);
          }
        }}
        disabled={disabled}
        placeholder={placeholder}
        className="phone-number-input"
      />
    </div>
  );
};

export default CountryPhoneInput;

